@use 'control-hint-vars';

:host {
  @include control-hint-vars.wb-control-hint-vars;
  display: block;
  margin-block-start: var(--control-hint-margin-block-start);
  color: var(--control-hint-color);
}
